export const Navigation = [
    {value:'indicadores', label:'PNCC - Indicadores'},
    {value:'pecc', label:'PNCC - PECC'},
    {value:'ndc', label:'PNCC - NDC'},
    {value:'otros', label:'Vinculación con otros elementos relevantes'},
    {value:'pregunta', label:'Vinculación PP-PNCC'},
    {value:'componente', label:'Tipo de Contribución'},
    {value:'cuantificacion', label:'Cuantificación'},
];

export const NavigationRequired = [
    {value:'identificacion', label:'PNCC - Indicadores'},
    {value:'indicadores', label:'PNCC - Indicadores'},
    {value:'pecc', label:'PNCC - PECC'},
    {value:'ndc', label:'PNCC - NDC'},
    {value:'otros', label:'Vinculación con otros elementos relevantes'},
    {value:'pregunta', label:'Vinculación PP-PNCC'},
    {value:'componente', label:'Tipo de Contribución'},
    {value:'cuantificacion', label:'Cuantificación'},
];